import { render, staticRenderFns } from "./BrowserProctoringMonitor.vue?vue&type=template&id=3c42c4ac&scoped=true&"
import script from "./BrowserProctoringMonitor.vue?vue&type=script&lang=js&"
export * from "./BrowserProctoringMonitor.vue?vue&type=script&lang=js&"
import style0 from "./BrowserProctoringMonitor.vue?vue&type=style&index=0&id=3c42c4ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c42c4ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
